__turbopack_context__.v({
  "slider": "slider-module-scss-module__Q95hDW__slider",
});
